
/* eslint-disable @typescript-eslint/no-shadow */
export namespace ProjectSortOrder {
  export enum ProjectSortOrder {
    ASCENDING = "ASCENDING",
    DESCENDING = "DESCENDING",
  }

  export interface ProjectSortOrderDTO {
    case: string;
  }

  export const fromDTO = (dto: ProjectSortOrderDTO): ProjectSortOrder => {
    if (dto === undefined || dto === null) {
      throw new InvalidProjectSortOrderError(
        `Invalid DTO ${dto} provided for ProjectSortOrder.ProjectSortOrder`
      );
    }
    switch (dto.case) {
      case "ASCENDING":
        return ProjectSortOrder.ASCENDING;
      case "DESCENDING":
        return ProjectSortOrder.DESCENDING;
      default:
        throw new InvalidProjectSortOrderError(
          `Case ${dto.case} is not valid case of ProjectSortOrder.ProjectSortOrder`
        );
    }
  };

  export const toDTO = (projectSortOrder: ProjectSortOrder): ProjectSortOrderDTO => {
    const enumDTO = {
      case: ProjectSortOrder[projectSortOrder],
    };
    return enumDTO;
  };
}

export class InvalidProjectSortOrderError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProjectSortOrderError";
  }
}
export class InvalidProjectSortOrderAscendingError extends InvalidProjectSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProjectSortOrderAscendingError";
  }
}

export class InvalidProjectSortOrderDescendingError extends InvalidProjectSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProjectSortOrderDescendingError";
  }
}
